import React from "react";
import Image01 from "../assets/profile.svg";
import moment from 'moment';
import { BsThreeDots } from "react-icons/bs";
import { auth } from "../firebase/firebase";
import { useBusiness } from "../context/BusinessContext";

const FeedBusiness = ({ business }) => {
  const { setSelectedBusiness } = useBusiness();
  return (
    <div className="border-2 p-3 rounded-xl mb-5">
      <div className="flex justify-between items-start mb-5">
        <div className="flex items-center">
          <img src={business?.ownerPhoto || Image01} alt="" className="w-[50px] h-[50px]" />
          <div className="ml-2">
            <div className="flex items-center">
              <p className="text-sm font-semibold">{business?.ownerName} .</p>
              <p className="text-xs ml-2">{ moment(business?.createdAt).fromNow() }</p>
            </div>
            <p className="text-xs">{business?.ownerLocation}</p>
          </div>
        </div>
        {auth.currentUser === business?.owner && <BsThreeDots className="text-4xl text-[#D2D2D2] cursor-pointer" onClick={() => setSelectedBusiness(business)} />}
      </div>

      <div className="flex justify-between">
        <div className="flex flex-col justify-between items-start w-[76%]">
          <div>
            <p className="font-medium text-sm">{business?.name}</p>
            <p className="text-xs font-medium">
              {business?.description}
            </p>
          </div>
          <button className="py-1 px-3 bg-primary text-white rounded-md hover:border-2 hover:border-primary hover:bg-transparent hover:text-primary">
            Massage
          </button>
        </div>
        <div className="w-[20%] h-[110px]">
          <img
            src={business?.image}
            alt=""
            className="w-full h-full object-fill rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default FeedBusiness;
